import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id D2AFF074-2CE4-442D-AF1A-64B168BC622A
 * name message-text
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-text.svg
 * tags
 */
export const MessageTextIcon = createSvgIcon(<><path d="M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M6,9H18V11H6M14,14H6V12H14M18,8H6V6H18" /></>, 'MessageTextIcon');
export default MessageTextIcon